import React from 'react';
import './BomAvailabilityPill.css';

/** Missing BOM parts on one order line. Matches the order-level count: unique part, negative qty available, not excluded. */
export function availabilityReportForLine(line, excludedParts = {}) {
    const bomParts = line?.bom?.bomParts || [];
    const seen = new Map();
    bomParts.forEach((bom) => {
        const key = bom?.prcpart;
        if (!key || bom?.archived || seen.has(key)) return;
        const part = bom?.part || {};
        const qtyAvail = (Number(part.qoh_cache) || 0) - (Number(part.qr_cache) || 0);
        seen.set(key, qtyAvail);
    });
    let missingPartsCount = 0;
    seen.forEach((qtyAvail, key) => {
        if (qtyAvail < 0 && !excludedParts[key]) missingPartsCount += 1;
    });
    return { missingPartsCount, totalPartsCount: seen.size };
}

const BomAvailabilityPill = ({ missing = 0, total = 0 }) => {
    const totalCount = Number(total) || 0;
    if (totalCount <= 0) return <span className="text-muted">-</span>;
    const missingCount = Number(missing) || 0;
    const complete = missingCount === 0;
    const label = `BOM ${missingCount} / ${totalCount}`;
    return (
        <span
            className={`bom-availability-pill ${complete ? 'is-complete' : 'is-missing'}`}
            title={complete ? `${totalCount} BOM parts available` : `${missingCount} of ${totalCount} BOM parts short`}
        >
            {label}
        </span>
    );
};

export default BomAvailabilityPill;
